module.exports = __webpack_public_path__ + "static/media/settings-inactive.0d3e731d.svg";